import React from 'react'
import InfiniteScroll from './InfiniteScroll'

function FeedDescription() {
  return (
    <section className="py-12">
     <div className="flex flex-col md:flex-row-reverse ">
       <div className="w-full md:w-[60%] lg:mx-[7%] lg:py-10  space-y-4 my-10">
         <h1 className="text-white my-5 font-bold  text-2xl md:text-4xl">
             A feed built just for you.
         </h1>
         <p className="text-white md:text-xl font-nunito font-medium indent-4">
           Our AI is constantly evolving to tailor to your needs. 
           Whether you are a professional looking for discussion on new policies in your field,
            or a beginner who is trying to learn something new each day, we help personalize your 
            feed so that you see only the things that you are most passionate about. 
         </p>
       </div>
         <div className="lg:m-10 w-full md:w-[40%]">
            <InfiniteScroll />
         </div>
     </div>

    </section>
  )
}

export default FeedDescription
